import {Category, DescribeSeatingPlanResponse} from '@wix/ambassador-seating-v1-seating-plan/types'
import {createAction, createAsyncThunk} from '@reduxjs/toolkit'
import {getEventId} from '@wix/wix-events-commons-statics'
import {SelectedSeat} from '../types/seating'
import {getTicketDefinitionByExternalId} from '../selectors/seating'
import {ThunkConfig} from './interfaces'

export const describeSeatingPlan = createAsyncThunk<DescribeSeatingPlanResponse, void, ThunkConfig>(
  'DESCRIBE_SEATING_PLAN',
  async (_, {getState, extra: {serverApi}}) => serverApi.describeSeatingPlan(getEventId(getState().event)),
)

export const selectPrice = createAsyncThunk<Category[], string, ThunkConfig>(
  'SELECT_PRICE',
  (selectedPrice, {getState}) => {
    const state = getState()
    const categories = state.seating.plan.categories
    return selectedPrice
      ? categories.filter(category => {
          const ticketDefinition = getTicketDefinitionByExternalId(state.tickets, category.externalId)
          return selectedPrice === ticketDefinition.price.value
        })
      : categories
  },
)

export const selectLocation = createAction<string>('SELECT_LOCATION')

export const selectSeat = createAction<SelectedSeat>('SELECT_SEAT')

export const selectSeats = createAction<SelectedSeat[]>('SELECT_SEATS')

export const unselectSeat = createAction<string>('UNSELECT_SEAT')

export const setShowAccessibilityMode = createAction<boolean>('SET_SHOW_ACCESSIBILITY_MODE')
